import cx from 'classnames'

type Props = {
  text: string
  onClick
  className?: string
}

const ZoneButton = ({ text, onClick, className }: Props) => {
  return (
    <div
      className={cx(
        'bg-coolGray-50 flex items-center justify-center hover:bg-orange-50 hover:text-orange-500 cursor-pointer relative group',
        'hover:font-medium',
        className
      )}
      onClick={() => {
        onClick()
      }}
    >
      <span
        className="text-coolGray-400 flex items-center justify-center cursor-pointer  text-center group-hover:text-orange-500"
        style={{ width: 202 }}
      >
        {text}
      </span>
    </div>
  )
}

export default ZoneButton
